/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { SearchResultError } from './SearchResultError.js';
import {
    SearchResultErrorFromJSON,
    SearchResultErrorFromJSONTyped,
    SearchResultErrorToJSON,
} from './SearchResultError.js';
import type { SearchResultItem } from './SearchResultItem.js';
import {
    SearchResultItemFromJSON,
    SearchResultItemFromJSONTyped,
    SearchResultItemToJSON,
} from './SearchResultItem.js';

/**
 * 
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {number}
     * @memberof SearchResult
     */
    searchId?: number;
    /**
     * 
     * @type {Array<SearchResultItem>}
     * @memberof SearchResult
     */
    items?: Array<SearchResultItem>;
    /**
     * 
     * @type {SearchResultError}
     * @memberof SearchResult
     */
    error?: SearchResultError;
}

/**
 * Check if a given object implements the SearchResult interface.
 */
export function instanceOfSearchResult(value: object): boolean {
    return true;
}

export function SearchResultFromJSON(json: any): SearchResult {
    return SearchResultFromJSONTyped(json, false);
}

export function SearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SearchResultItemFromJSON)),
        'error': json['error'] == null ? undefined : SearchResultErrorFromJSON(json['error']),
    };
}

export function SearchResultToJSON(value?: SearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'searchId': value['searchId'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SearchResultItemToJSON)),
        'error': SearchResultErrorToJSON(value['error']),
    };
}

